import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs';
import { NgrxService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
@Injectable({
	providedIn: 'root',
})
export class B2bService {
	constructor(
		private http: HttpClient,
		private ngrxService: NgrxService,
		private location: Location,
	) {}

	loadb2bInit() {
		return this.ngrxService.loadInitAPI('b2b', 'list');
	}

	loadb2bApi() {
		return this.getb2bList().pipe(
			map(data => {
				this.ngrxService.loadInitData('b2b', 'list', data);
			}),
		);
	}

	fetchb2bData() {
		return this.ngrxService.loadData('b2b', 'list');
	}

	getb2bList() {
		return this.http.get(environment.url.profile + '/b2b/company	');
	}
	addb2b(content: any) {
		return this.http
			.post(environment.url.profile + '/b2b/companies', content, {})
			.pipe(
				tap(() => {
					this.loadb2bApi().subscribe();
				}),
			);
	}
	deleteb2b(id: any) {
		return this.http
			.delete(environment.url.profile + `/b2b/company/${id}`)
			.pipe(tap(() => this.loadb2bApi().subscribe()));
	}
	updateb2b(id: any, content: any) {
		return this.http
			.put(environment.url.profile + `/b2b/company/${id}`, content, {})
			.pipe(
				tap(() => {
					this.loadb2bApi().subscribe();
				}),
			);
	}
}
